import React from "react";
import { motion } from "framer-motion";
import { formatMentions } from "../../../utils/formatMentions";
import "./TextPost.css";

const TextPost = ({ post }) => {
  return (
    <div className="cbx-text-post">
      {post.content && (
        <p className="cbx-text-post__content">{formatMentions(post.content)}</p>
      )}

      {/* Tags */}
      {post.tags && post.tags.length > 0 && (
        <motion.div
          className="cbx-text-post__tags"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          {post.tags.map((tag, index) => (
            <motion.span
              key={index}
              className="cbx-text-post__tag"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              #{tag}
            </motion.span>
          ))}
        </motion.div>
      )}
    </div>
  );
};

export default TextPost;
